import { useState, useEffect } from "react";

const Pagination = ({
	pageChangeHandler,
	totalRows,
	rowsPerPage,
	currentPage,
}) => {
	// Calculating max number of pages
	const noOfPages = Math.ceil(totalRows / rowsPerPage);

	// State variable to hold the current page. This value is
	// passed to the callback provided by the parent
	// const [currentPage, setCurrentPage] = useState(1);

	// Navigation arrows enable/disable state
	const [canGoBack, setCanGoBack] = useState(false);
	const [canGoNext, setCanGoNext] = useState(true);

	// These variables give the first and last record/row number
	// with respect to the current page
	const [pageFirstRecord, setPageFirstRecord] = useState(1);
	const [pageLastRecord, setPageLastRecord] = useState(rowsPerPage);

	// Onclick handlers for the butons
	const onNextPage = () => pageChangeHandler(currentPage + 1);
	const onPrevPage = () => pageChangeHandler(currentPage - 1);
	const onPageSelect = (pageNo) => pageChangeHandler(pageNo);

	// Disable previous and next buttons in the first and last page
	// respectively
	useEffect(() => {
		if (noOfPages === currentPage) {
			setCanGoNext(false);
		} else {
			setCanGoNext(true);
		}
		if (currentPage === 1) {
			setCanGoBack(false);
		} else {
			setCanGoBack(true);
		}
	}, [noOfPages, currentPage]);

	// To set the starting index of the page
	useEffect(() => {
		const skipFactor = (currentPage - 1) * rowsPerPage;
		// Some APIs require skip for paginaiton. If needed use that instead
		pageChangeHandler(skipFactor);
		pageChangeHandler(currentPage);
		setPageFirstRecord(skipFactor + 1);
	}, [currentPage]);

	// To set the last index of the page
	useEffect(() => {
		const count = pageFirstRecord + rowsPerPage;
		setPageLastRecord(count > totalRows ? totalRows : count - 1);
	}, [pageFirstRecord, rowsPerPage, totalRows]);

	const getVisiblePages = (page, total) => {
		if (total < 7) {
			return filterPages([1, 2, 3, 4, 5, 6], total);
		} else {
			if (page % 5 >= 0 && page > 4 && page + 2 < total) {
				return [1, page - 1, page, page + 1, total];
			} else if (page % 5 >= 0 && page > 4 && page + 2 >= total) {
				return [1, total - 3, total - 2, total - 1, total];
			} else {
				return [1, 2, 3, 4, 5, total];
			}
		}
	};

	const filterPages = (visiblePages, totalPages) => {
		return visiblePages.filter((page) => page <= totalPages);
	};

	return (
		<>
			{noOfPages > 1 ? (
				<div className="pagination row d-flex mt-5">
					<div className="pageInfo mt-3 col-2">
						Showing {pageFirstRecord} - {pageLastRecord} of {totalRows}
					</div>
					<div className="pagebuttons d-flex col-10">
						<button
							className="pageBtn"
							onClick={onPrevPage}
							disabled={!canGoBack}
							style={{ width: 140,backgroundColor:'green'}}
						>
							&#8249;
						</button>
						{getVisiblePages(currentPage, noOfPages).map(
							(num, index, array) => (
								<>
									{array[index - 1] + 2 < num ? (
										<div className="addDotsBefore">...</div>
									) : (
										""
									)}
									<button
										onClick={() => onPageSelect(num)}
										className={`${"pageBtn"} 
										${num === currentPage ? "activeBtn" : ""} 
										`}
										style={{ width: 140,backgroundColor:'#18dcff'}}
									>
										{array[index - 1] + 2 < num ? `${num}` : num}
										{/* {index + 1} */}
									</button>
								</>
							)
						)}
						<button
							className="pageBtn"
							onClick={onNextPage}
							disabled={!canGoNext}
							style={{ width: 140,backgroundColor:'blue'}}
						>
							&#8250;
						</button>
					</div>
				</div>
			) : null}
		</>
	);
};

export default Pagination;
